<template>
  <li class="list-item">
    <div class="d-flex justify-space-between">
      <div
        :class="{
          'list-item-inner flex-grow-1 px-3': true,
          'list-item-inner--editable': item.isEditable
        }"
      >
        <div class="d-flex justify-space-between align-center">
          <v-text-field
            v-if="item.isEditable"
            v-model="email"
            :disabled="item.isReadOnly"
            :placeholder="$t('player_registration.type_email')"
            class="common-player-profile-form-field__text-field font-weight-medium mr-2"
            dense
            hide-details
            outlined
            @keydown.enter="handleSaveFanOrFollower"
          />
          <div v-else>
            <span class="font-weight-medium">
              {{ item.email }}
            </span>
            <!--            <v-tooltip bottom>-->
            <!--              <template v-slot:activator="{ on, attrs }">-->
            <!--                <v-icon-->
            <!--                  :color="item.registeredUser ? '#00ff00' : '#ff0000'"-->
            <!--                  v-bind="attrs"-->
            <!--                  v-on="on"-->
            <!--                  >mdi-circle-small</v-icon-->
            <!--                >-->
            <!--              </template>-->
            <!--              <span>{{-->
            <!--                item.registeredUser-->
            <!--                  ? $t("player_registration.registered")-->
            <!--                  : $t("player_registration.not_registered")-->
            <!--              }}</span>-->
            <!--            </v-tooltip>-->
          </div>
          <CommonSelectButton
            :changeValue="handleChangeFanOrFollowerType"
            :disabled="!item.isEditable || item.isReadOnly"
            :invalid="!!validationMessage"
            :item="item"
            :options="options"
            :placeholder="`${$t('player_registration.fan_type')}*`"
            :value="item.fanType"
          />
        </div>
      </div>
      <div v-if="item.isEditable" class="list-item__buttons-wrapper">
        <CommonButtonIcon
          :disabled="!item.isEditable"
          :handleClick="handleCloseEditFanOrFollower"
          icon="mdi-close"
        />
        <CommonButtonIcon
          :disabled="!item.isEditable"
          :handleClick="handleSaveFanOrFollower"
          icon="mdi-check"
        />
      </div>
      <div v-else-if="!item.isReadOnly" class="list-item__buttons-wrapper">
        <CommonButtonIcon
          :disabled="!item.isEditable && isAnyFanOrFollowerListItemEditable"
          :handleClick="() => (isDeleteModalOpen = true)"
          icon="mdi-trash-can-outline"
        />
        <CommonButtonIcon
          :disabled="!item.isEditable && isAnyFanOrFollowerListItemEditable"
          :handleClick="handleEditFanOrFollower"
          icon="mdi-file-document-edit-outline"
        />
      </div>
      <CommonDeleteModal
        :approveAction="handleDeleteFanOrFollower"
        :closeModal="() => (isDeleteModalOpen = false)"
        :isOpen="isDeleteModalOpen"
        :message="$t('alert.remove_item')"
      />
    </div>
    <VMessages
      v-if="item.isEditable && validationMessage"
      :value="[validationMessage]"
      class="red--text mt-2"
    />
  </li>
</template>

<script>
import CommonSelectButton from "../common/CommonSelectButton";
import CommonDeleteModal from "../common/CommonDeleteModal";
import {
  FanAndFollowersNames,
  FanAndFollowersTypes
} from "../enums/FanAndFollowersTypes";
import CommonButtonIcon from "./CommonButtonIcon";
import { i18n } from "../../../plugins/i18n";
import { RegExps } from "../enums/RegExps";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "FanOrFollowerListItem",
  components: { CommonSelectButton, CommonDeleteModal, CommonButtonIcon },
  props: {
    item: {
      type: Object,
      required: true
    },
    changeItem: {
      type: Function,
      required: true
    },
    isAnyFanOrFollowerListItemEditable: {
      type: Boolean,
      required: true
    },
    fansOrFollowers: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    options: [
      {
        name: FanAndFollowersNames.FAN,
        value: FanAndFollowersTypes.FAN
      },
      {
        name: FanAndFollowersNames.FOLLOWER,
        value: FanAndFollowersTypes.FOLLOWER
      }
    ],
    email: "",
    fanType: "",
    isDeleteModalOpen: false,
    validationMessage: ""
  }),

  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "fansAndFollowers",
      "playerRegistrationDetails",
      "playerRegistration"
    ])
  },
  methods: {
    ...mapMutations(ModuleTypes.PLAYER_REGISTRATION, ["setFansAndFollowers"]),
    handleDeleteFanOrFollower(isNewItem) {
      const { email, fanType } = this.item;
      if (!isNewItem) {
        const added = this.fansOrFollowers
          .map(({ email, fanType }) => ({ email, type: fanType }))
          .filter(
            ({ email: id1 }) =>
              !this.playerRegistrationDetails.fansAndFollowersList.some(
                ({ email: id2 }) => id2 === id1
              )
          )
          .filter(item => item.email !== email);

        this.setFansAndFollowers({
          fansAndFollowers: {
            ...(added?.length > 0
              ? {
                  added
                }
              : {
                  added: []
                }),
            deleted: [
              ...this.fansAndFollowers.deleted,
              { email, type: fanType }
            ]
          }
        });
      }
      this.changeItem && this.changeItem(this.item);
    },

    handleEditFanOrFollower() {
      this.email = this.item.email;
      this.fanType = this.item.fanType;
      this.changeItem &&
        this.changeItem(this.item, { ...this.item, isEditable: true });
    },

    handleCloseEditFanOrFollower() {
      this.validationMessage = "";
      if (this.item.isNewItem) {
        this.handleDeleteFanOrFollower(this.item.isNewItem);
      } else {
        this.changeItem &&
          this.changeItem(this.item, {
            ...this.item,
            fanType: this.item.fanType,
            isEditable: false
          });
      }
    },

    handleSaveFanOrFollower() {
      const { email, fanType, item } = this;
      if (!email || !fanType) {
        this.validationMessage = i18n.tc("validation.fill_in_all_fields");
      } else if (!email?.match(RegExps.EMAIL)) {
        this.validationMessage = i18n.tc("validation.invalid_email");
      } else if (
        item?.isNewItem &&
        this.fansOrFollowers.find(item => item.email === email)
      ) {
        this.validationMessage = i18n.tc("validation.email_is_already_added");
      } else {
        this.changeItem &&
          this.changeItem(item, {
            ...item,
            email,
            fanType,
            isEditable: false
          });

        const fansOrFollowersArr = this.fansOrFollowers.map(
          ({ email, fanType }) => ({
            email,
            fanType
          })
        );

        const updatedItemsToAdd = this.fansOrFollowers
          .map(({ email, fanType }) => ({ email, type: fanType }))
          .filter(
            ({ email: id1 }) =>
              !this.playerRegistrationDetails.fansAndFollowersList.some(
                ({ email: id2 }) => id2 === id1
              )
          );

        const updatedItemsToDelete = this.playerRegistrationDetails.fansAndFollowersList
          .map(({ email, fanType }) => ({ email, type: fanType }))
          .filter(
            ({ email: id1 }) =>
              !this.fansOrFollowers.some(({ email: id2 }) => id2 === id1)
          );

        const deleted = fansOrFollowersArr.filter(
          ({ email: id1 }) =>
            !this.fansOrFollowers.some(({ email: id2 }) => id2 === id1)
        );

        this.setFansAndFollowers({
          fansAndFollowers: {
            ...(updatedItemsToAdd?.length > 0
              ? {
                  added: updatedItemsToAdd
                }
              : {
                  added: []
                }),
            ...(deleted?.length > 0 || updatedItemsToDelete?.length > 0
              ? {
                  deleted: [...deleted, ...updatedItemsToDelete]
                }
              : {
                  deleted: []
                })
          }
        });
        this.validationMessage = "";
      }
    },

    handleChangeFanOrFollowerType(value) {
      this.fanType = value;
    }
  }
};
</script>

<style scoped>
.list-item-inner {
  padding: 3px 0;
  border-radius: 10px;
  background-color: var(--content-bg-color);
  border: 1px solid var(--divider-color);
}

.list-item-inner--editable {
  background-color: var(--white-color);
}

.list-item:not(:last-of-type) {
  margin-bottom: 5px;
}

.common-player-profile-form-field__text-field {
  font-size: 13px;
}

.common-player-profile-form-field__text-field >>> fieldset {
  border: none;
}
.common-player-profile-form-field__text-field >>> .v-input__slot {
  padding: 0 !important;
  min-height: 20px !important;
}

.list-item >>> .common-dialog {
  display: none;
}

.list-item__buttons-wrapper {
  display: flex;
  align-items: center;
}
</style>
